import React from 'react';
import { createRoot } from 'react-dom/client'; // Only import createRoot
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Create a root and render the app
const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker setup (unchanged)
serviceWorker.unregister();